import React, { useEffect, useState } from 'react';
import BackspaceIcon from '@mui/icons-material/Backspace';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AddTaskIcon from '@mui/icons-material/AddTask';
import "./TodoCards.css"
import { IconButton } from '@mui/material';
import instance from './axios';
function TodoCards() {
    const [List, setList] = useState([]);
    const [name, setName] = useState("");
    const [desc, setdesc] = useState("");
    async function fetchDataStart() 
    {
            const req = await instance.get("https://todo-backend-504dzpfk3-pavan2108.vercel.app/todo/cards");
            setList(req.data)
    }

    const asyncPostCall  = async () => {
        const body = {
            id : List.length,
            name : name,
            description : desc,
            completed : false
        }
        const response = await instance.post("https://todo-backend-504dzpfk3-pavan2108.vercel.app/todo/cards", body);
        setName("");
        setdesc("");
        fetchDataStart();
    }

    const asyncPutCall = async (id, completed) => {
        const data = {
            completed : !completed
        }
        const req = await instance.put(`https://todo-backend-504dzpfk3-pavan2108.vercel.app/todo/update/${id}`, data);
        fetchDataStart();
    }

    const asyncDeleteCall = async (id) => {
        const req = await instance.delete("https://todo-backend-504dzpfk3-pavan2108.vercel.app/todo/delete/" + id);
        fetchDataStart();
    }

    let handleSubmit = (event) => {
        event.preventDefault();
        asyncPostCall()
    }
    useEffect(() => {
        fetchDataStart();
    }, [])

    return (
        <>
        <div className="addTodoCard">
            <h2>Add item to todo</h2>
        <form className="form" onSubmit={handleSubmit}>
            <div className="form__input">
            <input type="text" name="TodoName" id="TodoName" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)}/>
            <textarea name="TodoDesc" id="TodoDesc" placeholder="Description" value={desc} onChange={(e) => setdesc(e.target.value)}/>
            </div>
            <div className="submitBtn">
                <IconButton onClick={() => asyncPostCall()}>
                    <AddTaskIcon fontSize="large" />
                </IconButton>
                <p>Add Task</p>
            </div>
            
        </form>
        </div>
        <div className="todoCards">
            {List.reverse().map((list) => (
                <>
                <div className="cardContent" key={list._id} id={list.id}>
                <div className="checkbox">
                    <IconButton onClick={() => asyncPutCall(list._id, list.completed)}>
                        {list.completed?
                        <CheckBoxIcon fontSize="large" />:
                        <CheckBoxOutlineBlankIcon fontSize="large" />
                        }
                    </IconButton>                    
                </div>
                <div className="content">
                    <p>{list.name}</p>
                    <hr/>
                    <p>{list.description}</p>
                </div>
                <div className="delete">
                    <IconButton onClick={() => asyncDeleteCall(list._id)}>
                        <BackspaceIcon fontSize='large'/>
                    </IconButton>
                    <p className="text">Remove</p>
                </div>
            </div>
                </>
                
            ))}
            
        </div>
        </>
        
    )
}


export default TodoCards
